// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__Cs9Ri","item":"BottomNav_item__aVity","icon":"BottomNav_icon__XqcCr","label":"BottomNav_label__NBZ1N","itemActive":"BottomNav_itemActive__Tndxz"};